// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchBar-cls1___925c7b716601f2eed2d{/*!*/}.SearchBar-cls2___54c172fc1626fbf1d33{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SearchBar-cls1___925c7b716601f2eed2d",
	"cls2": "SearchBar-cls2___54c172fc1626fbf1d33 SearchBar-cls1___925c7b716601f2eed2d"
};
export default ___CSS_LOADER_EXPORT___;
